var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "50", height: "50", viewBox: "0 0 50 50", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement(
      "title",
      null,
      "Page 1"
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("circle", { cx: "25", cy: "25", r: "25", fill: "#5B89EE" }),
      React.createElement("path", { d: "M12.956 16.938l12.353 11m0 0l12.353-11", stroke: "#FFFEFE", strokeWidth: "2", strokeLinecap: "square" }),
      React.createElement("path", { stroke: "#FFF", strokeWidth: "2", strokeLinecap: "square", d: "M12.132 15.938h25.53M12.132 33.938h25.53" }),
      React.createElement("path", { stroke: "#FFF", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", d: "M12.132 33.938v-18" }),
      React.createElement("path", { stroke: "#FFF", strokeWidth: "2", strokeLinecap: "square", d: "M38.485 33.938v-18" }),
      React.createElement("path", { fill: "#FFF", d: "M12.544 16.438h1v1h-1z" }),
      React.createElement("path", { fill: "#FFFEFE", d: "M37.25 16.438h1v1h-1zM25.309 28.438l.412-1h-.824z" })
    )
  );
});


// WEBPACK FOOTER //
// ./src/assets/icons/email_icon_in_circle.svg